import type { ExamRecord } from '@/types';

interface ParentExamRecordSectionProps {
  records: ExamRecord[];
}

export default function ParentExamRecordSection({ records }: ParentExamRecordSectionProps) {
  return (
    <section className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
      <h2 className="flex flex-wrap items-center gap-2 text-sm font-bold text-foreground-950">
        <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
          <i className="ri-file-list-3-line"></i>
        </span>
        학교기출 결과
        <span className="rounded-full bg-background-200 px-2.5 py-0.5 text-[11px] font-semibold text-foreground-600">
          {records.length}건
        </span>
      </h2>

      {records.length === 0 ? (
        <p className="mt-4 rounded-lg border border-dashed border-background-300 py-8 text-center text-sm text-foreground-500">
          아직 기록된 학교기출 결과가 없어요.
        </p>
      ) : (
        <div className="mt-4 flex flex-col gap-2.5">
          {records.map((r) => (
            <div
              key={r.id}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-4 sm:flex-row sm:items-center sm:justify-between"
            >
              <div className="min-w-0">
                <p className="text-sm font-semibold text-foreground-950">
                  {r.year}년 {r.grade} {r.semester} {r.exam_type}
                </p>
                <p className="mt-0.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-building-line"></i>
                    {r.school_name || '학교 미입력'}
                  </span>
                </p>
              </div>
              <div className="flex items-center gap-2">
                <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
                  점수 {r.score || '-'}
                </span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                  {r.expected_grade || '등급 미입력'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}